module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABkAQMAAADOquA5AAAAA1BMVEXNCgokNzldAAAACXBIWXMAAABIAAAASABGyWs+AAAAD0lEQVQoz2NgGAWjgPoAAAJYAAF1NoZ3AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE1LTAzLTExVDA4OjQ5OjUxLTA3OjAwCL4hJQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNS0wMy0xMVQwODo0OTo1MS0wNzowMHnjmZkAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/vendor/jquery-ui-themes/cupertino/images/ui-bg_flat_15_cd0a0a_40x100.png
 ** module id = 889
 ** module chunks = 0
 **/